<template>
  <div>
    <DistributionMailsDataTable
        :loading="loading"
        :mails="mails"
        :post-indexes="postIndexes"
        :total="total"
        @update="onUpdate"
        @send-to-post-office="onSendToPostOffice"
        :allow-distribution-by-post-offices="allowDistributionByPostOffices"
    />

    <v-snackbar v-model="noMailsToPrint"
                :timeout="5000"
                :top="true"
                color="info"
    >
      Нет писем для распечатки
    </v-snackbar>
  </div>
</template>

<script>
import _ from "underscore";
import {AllowDistributionByPostOffices} from "@/enums/permission";
import {LAYOUT_LOADING_START, LAYOUT_LOADING_STOP, LAYOUT_TITLE_CHANGED} from "@/store/modules/layout/actions";
import MailService from "@/services/mail.service";
import Moment from "moment";
import Mappers from "@/mappers";
import DistributionService from "@/services/distribution.service";
import DistributionMailsDataTable from "@/components/DistributionMailsDataTable";
import PostIndexService from "@/services/post.index.service";
import Mapper from "@/mappers";

export default {
  name: "DistributionMailsView",
  components: {
    DistributionMailsDataTable
  },
  data() {
    return {
      mails: [],
      postIndexes: [],
      total: 0,
      loading: false,
      noMailsToPrint: false,
      noMailsToSend: false,
    }
  },
  computed: {
    allowDistributionByPostOffices() {
      return !!_.find(this.$store.getters.appLogin.permissions, p => {
        return p === AllowDistributionByPostOffices
      })
    }
  },
  methods: {
    loadPostIndexes() {
      PostIndexService.getAll({})
          .then(response => {
            this.postIndexes = _.map(response.data, Mapper.mapPostIndex)
          })
    },
    reloadMails(options, filters) {
      this.loading = true;
      this.$store.dispatch(LAYOUT_LOADING_START)
      const {sortBy, sortDesc, page, itemsPerPage} = options;
      const {
        region,
        area,
        postIndex,
        isDistributed,
        isPrinted,
        isPosted,
        isPerformed,
        isExpress,
        start,
        end
      } = filters;
      const skip = (page - 1) * itemsPerPage;

      MailService.getDistributionDataTable({
        skip: skip,
        limit: itemsPerPage,
        sort: sortBy.length === 1 ? sortBy[0] : null,
        desc: sortDesc.length === 1 ? sortDesc[0] : null,
        client: this.$store.getters.appActiveClient,
        region: region,
        area: area,
        postIndex: postIndex,
        isDistributed: isDistributed,
        isPrinted: isPrinted,
        isPosted: isPosted,
        isPerformed: isPerformed,
        isExpress: isExpress,
        start: start ? Moment(start, 'YYYY-MM-DD') : null,
        end: end ? Moment(end, 'YYYY-MM-DD') : null
      })
          .then(response => {
            this.mails = _.map(response.data.Records, mailViewModel => {
              return Mappers.mapMail(mailViewModel)
            })
            this.total = response.data.Total;
          }, () => {
          })
          .finally(() => {
            this.loading = false;
            this.$store.dispatch(LAYOUT_LOADING_STOP)
          })
    },
    onUpdate(options, filters) {
      this.reloadMails(options, filters)
    },
    onSendToPostOffice(options, filters) {
      const {region, area} = filters;

      this.loading = true;
      this.$store.dispatch(LAYOUT_LOADING_START)
      this.noMailsToSend = false;
      DistributionService.sendToPostOffice({
        mails: this.mails,
        client: this.$store.getters.appActiveClient,
        region: region,
        area: area
      })
          .then(response => {
            if (response.status === 204) {
              this.noMailsToSend = true
            } else {
              // print success message
            }
          })
          .finally(() => {
            this.loading = false;
            this.$store.dispatch(LAYOUT_LOADING_STOP)

            this.reloadMails(options, filters)
          })

    },
  },
  created() {
    if (this.allowDistributionByPostOffices) {
      this.loadPostIndexes()
      this.$store.dispatch(LAYOUT_TITLE_CHANGED, 'Распределение писем')
    } else {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>

</style>
